import { cn } from '@/shared/lib/cn';
import { formatInitials } from '@/shared/lib/format';

export type UserAvatarProps = {
  nome: string;
  fotoUrl?: string | null;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
};

const sizeClasses: Record<NonNullable<UserAvatarProps['size']>, string> = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-14 w-14 text-base',
  xl: 'h-20 w-20 text-lg',
};

export const UserAvatar = ({ nome, fotoUrl, size = 'md', className }: UserAvatarProps) => {
  return (
    <div
      // aspect-square eh defesa em profundidade: garante 1:1 mesmo se o
      // parent for flex e tentar comprimir ou se um className externo
      // sobrescrever uma das dimensoes. Junto com overflow-hidden +
      // object-cover na img, blinda contra qualquer distorcao visual.
      className={cn(
        'inline-flex aspect-square shrink-0 items-center justify-center overflow-hidden rounded-full bg-muted font-semibold text-foreground',
        sizeClasses[size],
        className,
      )}
      aria-label={`Avatar de ${nome}`}
    >
      {fotoUrl ? (
        <img
          src={fotoUrl}
          alt={nome}
          draggable={false}
          className="h-full w-full object-cover"
        />
      ) : (
        <span>{formatInitials(nome)}</span>
      )}
    </div>
  );
};
